import React from 'react'
// components
import Header from 'components/UI/Modal/Header'
import DrawerModal from 'components/UI/Drawer'
import UpdateForm from './UpdateForm'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/modals'
// types
import { IApiClient } from 'types/graphql'
// views
import { Wrapper } from './views'

interface ModalData {
  isOpen: boolean
  client?: IApiClient
}

const ApiClientUpdateModal: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, client }
  } = useModalData<ModalData>({ modalType: Modals.API_CLIENT_UPDATE_MODAL })

  const initialValues = React.useMemo(
    () => ({
      name: client?.name || '',
      active: !!client?.active,
      allowedIpRanges: client?.allowedIpRanges || []
    }),
    [client]
  )

  return (
    <DrawerModal isOpen={isOpen} width='560px' hideModal={hideModal}>
      <Header handleClearClick={hideModal}>Update API client</Header>
      <Wrapper>
        {isOpen && client && <UpdateForm clientId={client.id} hideModal={hideModal} initialValues={initialValues} />}
      </Wrapper>
    </DrawerModal>
  )
}

export default ApiClientUpdateModal
